import { initSentry } from "@kalodata/sentry";

window.CLIP_VERSION = CLIP_VERSION;

const isLocalHost = ["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname);

if (import.meta.env.MODE !== "development" && !isLocalHost) {
  initSentry({
    dsn: "https://c7de3f67d1392e53f74273c6d0778266@o4511347902578688.ingest.us.sentry.io/4511494772817920",
    project: "kaloclip-web",
    release: CLIP_VERSION,
    environment: import.meta.env.MODE,
  });
}
